import type { DaylightModeBand } from "@shared/daylightMode";
import { isDaylightModeBand } from "@shared/daylightMode";

const ENABLED_KEY_PREFIX = "clarity:daylightMode:enabled";
const PREVIEW_KEY_PREFIX = "clarity:daylightMode:previewBand";

function enabledKey(userId?: number | null): string {
  return userId != null && userId > 0 ? `${ENABLED_KEY_PREFIX}:${userId}` : ENABLED_KEY_PREFIX;
}

function previewKey(userId?: number | null): string {
  return userId != null && userId > 0 ? `${PREVIEW_KEY_PREFIX}:${userId}` : PREVIEW_KEY_PREFIX;
}

function readBool(key: string): boolean {
  try {
    return globalThis.localStorage?.getItem(key) === "1";
  } catch {
    return false;
  }
}

function writeBool(key: string, value: boolean): void {
  try {
    globalThis.localStorage?.setItem(key, value ? "1" : "0");
  } catch {
    /* private mode / quota */
  }
}

export function readDaylightModeEnabled(userId?: number | null): boolean {
  if (userId != null && userId > 0) {
    const scoped = readBool(enabledKey(userId));
    if (scoped) return true;
  }
  return readBool(enabledKey());
}

export function writeDaylightModeEnabled(enabled: boolean, userId?: number | null): void {
  writeBool(enabledKey(userId), enabled);
  if (userId != null && userId > 0) {
    writeBool(enabledKey(), enabled);
  }
}

export function readDaylightModePreviewBand(userId?: number | null): DaylightModeBand | null {
  try {
    const raw = globalThis.localStorage?.getItem(previewKey(userId));
    if (raw && isDaylightModeBand(raw)) return raw;
  } catch {
    /* ignore */
  }
  return null;
}

export function writeDaylightModePreviewBand(band: DaylightModeBand | null, userId?: number | null): void {
  try {
    const key = previewKey(userId);
    if (!band) globalThis.localStorage?.removeItem(key);
    else globalThis.localStorage?.setItem(key, band);
  } catch {
    /* ignore */
  }
}
